import { StepsTheme as Steps } from 'chakra-ui-steps'

export const stepsStyles = {
  components: {
    Steps,
  },
}
